<template>
  <footer class="container-footer">
    <section class="footer">
      <div class="grid md:grid-cols-5 gap-8 border-b border-gray-700 pb-8">
        <!-- Mapa -->
        <div>
          <h3 class="font-semibold mb-4">Mapa</h3>
          <ul class="space-y-2 text-sm menu-rodape">
            <li>
              <router-link to="/" class="transition">Home</router-link>
            </li>
            <li>
              <router-link to="/alliances" class="transition"
                >Alliance</router-link
              >
            </li>
            <li>
              <router-link to="/solutions" class="transition"
                >Solutions</router-link
              >
            </li>
            <li>
              <router-link to="/travel" class="transition"
                >Travel Design</router-link
              >
            </li>
            <li>
              <router-link to="/alliances" class="transition"
                >Explore</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Contato -->
        <div v-if="contatos.length > 0">
          <h3 class="font-semibold mb-4">{{ $t('contato') }}</h3>
          <div
            class="flex items-center contato-email gap-2 menu-rodape mb-2"
            v-for="value in contatos[0].detalhes"
            :key="value.id"
          >
            <img src="@/assets/icon-email.svg" alt="email" class="w-5 h-5" />
            <a :href="`mailto:${value.endereco}`" class="transition">
              {{ value.endereco }}
            </a>
          </div>

          <!-- Telefone -->
          <div
            class="flex items-center contato-email gap-2 menu-rodape"
            v-for="value in contatos[4].detalhes"
            :key="value.id"
          >
            <img src="@/assets/whats-footer.svg" alt="email" class="w-5 h-5" />
            <a :href="`${value.url}`" class="transition" target="_blank">
              {{ value.endereco }}
            </a>
          </div>
        </div>

        <!-- Parceiros -->
        <div class="menu-rodape">
          <h3 class="font-semibold mb-4 text-gray-200">
            {{ $t('parceiros') }}
          </h3>
          <router-link to="/solutions" class="transition texto-white-rodape">
            {{ $t('seja_parceiro') }}</router-link
          >
        </div>

        <!-- Redes Sociais -->
        <div v-if="contatos.length > 1">
          <h3 class="font-semibold mb-4">{{ $t('redes_sociais') }}</h3>
          <div class="icones-redes">
            <div v-for="value in contatos[3].detalhes" :key="value.id">
              <a :href="value.url" class="hover:opacity-80 transition">
                <img
                  :src="require(`@/assets/${value.icone}`)"
                  class="w-5 h-5"
                />
              </a>
            </div>
          </div>
        </div>

        <!-- Newsletter -->
        <div>
          <h3 class="font-semibold mb-4 text-gray-200">Newsletter</h3>
          <form class="flex flex-col gap-3">
            <input
              type="email"
              v-model="form"
              :placeholder="$t('digite_seu_email')"
              class="px-4 py-2 rounded-md text-sm text-gray-800 focus:outline-none"
            />
            <button
              type="submit"
              @click.prevent="submit"
              class="btn-newsletter text-sm py-2 rounded-md transition"
            >
              {{ $t('inscrever_se') }}
            </button>
            <template v-if="sucesso">
              <p>
                {{ getSuccess(sucesso) }}
              </p>
            </template>
            <template v-else-if="error">
              <p>{{ getError(error) }}</p>
            </template>
          </form>
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row justify-between items-center mt-6 text-xs menu-rodape gap-2"
      >
        <p class="txt-direitos">
          {{ $t('todos_direitos_reservados') }}
        </p>

        <div class="flex items-center gap-2">
          <router-link to="/politica-privacidade" class="transition">
            {{ $t('politica_de_privacidade') }}
          </router-link>

          <span class="hidden md:inline">•</span>

          <a
            href="https://creativeflux.com.br"
            target="_blank"
            rel="noopener noreferrer"
            class="transition credit-creativeflux"
            aria-label="Site da CreativeFlux - design e desenvolvimento"
          >
            Feito com carinho por <strong>CreativeFlux</strong>
          </a>
        </div>
      </div>

    </section>
  </footer>
</template>

<script>
import { api } from '@/services/services';

export default {
  name: 'FooterContainer',
  data() {
    return {
      contatos: [],
      form: '',
      sucesso: '',
      error: '',
    };
  },
  methods: {
    async buscarContatos() {
      try {
        const response = await api.get('contatos/lista');
        this.contatos = response.data;
      } catch (error) {
        console.error('Erro ao buscar os contatos:', error);
      }
    },
    async submit() {
      this.sucesso = '';
      this.error = '';

      const formData = new FormData();
      formData.append('email', this.form);

      try {
        const response = await api.post('newsletter/assinar', formData);

        if (response.data.error) {
          this.error = response.data.error;
        } else {
          this.sucesso = response.data;
          this.form = '';
        }
      } catch (erro) {
        // Se o servidor enviou alguma mensagem de erro, exibe ela
        if (erro.response && erro.response.data && erro.response.data.error) {
          this.error = erro.response.data;
        } else {
          this.error = 'Erro ao enviar o formulário. Tente novamente.';
        }
      }
    },
    getSuccess(msg) {
      if (!msg) return '';
      const lang = this.$i18n.locale;
      return lang === 'en' ? msg.message_en : msg.message;
    },
    getError(msg) {
      if (!msg) return '';
      const lang = this.$i18n.locale;
      return lang === 'en' ? msg.error_en : msg.error;
    },
  },
  mounted() {
    this.buscarContatos();
  },
};
</script>

<style scoped>
.container-footer {
  background: #03101d;
  padding: 40px 0;
}
.footer {
  max-width: 1360px;
  margin: 0 auto;
  color: #e0effe !important;
}
input:focus {
  box-shadow: 0 0 0 2px #1e406a33;
}

.txt-direitos {
  color: #e0effe !important;
  font-size: 12px;
}

.btn-newsletter {
  background: #5782ae;
  color: #fff;
  border-radius: 6px;
  padding: 10px;
}

.icones-redes {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.menu-rodape a {
  color: #e0effe !important;
}

.menu-rodape a:hover {
  color: #b9d5f1 !important;
}
@media (max-width: 640px) {
  .container-footer {
    padding: 30px 0;
  }

  .contato-email a {
    width: fit-content;
  }

  .contato-email img {
    width: fit-content;
    margin: 0;
    padding: 0;
  }

  .footer {
    padding: 0 16px;
  }

  /* grid vira coluna */
  .grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  h3 {
    text-align: center;
  }

  .menu-rodape {
    text-align: center;
  }

  /* contatos centralizados */
  .menu-rodape,
  .menu-rodape a {
    justify-content: center;
  }

  /* redes sociais central */
  .icones-redes {
    justify-content: center;
  }

  /* newsletter */
  form {
    align-items: stretch;
  }

  .btn-newsletter {
    width: 100%;
  }

  /* rodapé final */
  .txt-direitos {
    text-align: center;
    margin-bottom: 8px;
  }

  .footer > div:last-child {
    text-align: center;
    gap: 8px;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  .footer {
    padding: 0 24px;
  }

  .grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  /* newsletter ocupa linha inteira */
  .grid > div:last-child {
    grid-column: span 2;
  }

  .icones-redes {
    gap: 16px;
  }
}
</style>
